import { render } from "./NavBarView.vue?vue&type=template&id=48ef92ce&scoped=true"
import script from "./NavBarView.vue?vue&type=script&lang=js"
export * from "./NavBarView.vue?vue&type=script&lang=js"

import "./NavBarView.vue?vue&type=style&index=0&id=48ef92ce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ef92ce"]])

export default __exports__